import { forwardRef } from 'react';
import type { LabelHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

/**
 * Label pra campos de formulário.
 *
 * Mostra asterisco vermelho automaticamente quando `required` é true.
 */
interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
}

export const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ required, children, className, ...props }, ref) => (
    <label
      ref={ref}
      className={cn(
        'block text-sm font-medium text-ink-1 dark:text-ink-dark-1 mb-1.5',
        className
      )}
      {...props}
    >
      {children}
      {required && <span className="text-red ml-0.5" aria-hidden="true">*</span>}
    </label>
  )
);
Label.displayName = 'Label';
